import { render } from "./notasFundamentalUmOuERN.vue?vue&type=template&id=5fc00f7a&scoped=true"
import script from "./notasFundamentalUmOuERN.vue?vue&type=script&lang=js"
export * from "./notasFundamentalUmOuERN.vue?vue&type=script&lang=js"

import "./notasFundamentalUmOuERN.vue?vue&type=style&index=0&id=5fc00f7a&lang=css"
import "./notasFundamentalUmOuERN.vue?vue&type=style&index=1&id=5fc00f7a&scoped=true&lang=css"
import "./notasFundamentalUmOuERN.vue?vue&type=style&index=2&id=5fc00f7a&scoped=true&lang=css"
import "./notasFundamentalUmOuERN.vue?vue&type=style&index=3&id=5fc00f7a&lang=scss&scoped=true"
import "./notasFundamentalUmOuERN.vue?vue&type=style&index=4&id=5fc00f7a&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc00f7a"]])

export default __exports__